module.exports = __webpack_public_path__ + "public/images/slider/filimonova.7feaedae207c8e2e9df5b4432fc821af.png";